import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class EtablissementService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification/liste-etablissement'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getEtablissementsByUniversite = async (idUniversite) => {
  const response = await axios.get(`${this.API_URL}?idUniversite=${idUniversite}`);
  return response.data;
};

}